import { BrowserTracing, init, Replay, vueRouterInstrumentation, captureException, captureMessage, setUser } from "@sentry/vue";

const useSentry = (Vue, router) => {
  init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: vueRouterInstrumentation(router),
      }),
      new Replay(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/api\.baseball\.flightscope\.dev/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    profilesSampleRate: 1.0,

    environment: [process.env.NODE_ENV, process.env.VUE_APP_ENVIRONMENT, process.env.VUE_APP_SPORT_TYPE].join('-').toLowerCase(),
  });
}

export { captureException, captureMessage, setUser };

export default useSentry;
